import React from 'react';
import HeroSection from './sections/HeroSection';
import HowItWorksSection from './sections/HowItWorksSection';
import BenefitsSection from './sections/BenefitsSection';
import TestimonialsSection from './sections/TestimonialsSection';
import LeadFormSection from './sections/LeadFormSection';
import CompanyAdvantagesSection from './sections/CompanyAdvantagesSection';
import WorkShowcaseSection from './sections/WorkShowcaseSection';
import EnergySystemSection from './sections/EnergySystemSection';
import FinalCTASection from './sections/FinalCTASection';
import { Toaster } from './ui/toaster';
import SEO from './SEO';

const LandingPage = () => {
  const sectionVisibility = {
    testimonials: false,
    workShowcase: false,
  };

  return (
    <div className="bg-white">
      {/* SEO Meta Tags */}
      <SEO />
      
      {/* Header & Footer entfernt - Seite wird im iframe angezeigt */}
      {/* min-h-screen ENTFERNT: Verhindert Auto-Resize-Loops im iframe */}
      
      {/* Main Content */}
      <main className="w-full" style={{ paddingTop: 0 }}>
        <HeroSection />
        
        <HowItWorksSection />
        <BenefitsSection />

        {sectionVisibility.testimonials && (
          <TestimonialsSection />
        )}
        <LeadFormSection />
        <CompanyAdvantagesSection />
        {sectionVisibility.workShowcase && (
          <WorkShowcaseSection />
        )}
        <EnergySystemSection />
        
        {/* Dunkle CTA Section ganz unten */}
        <FinalCTASection />
      </main>
      
      <Toaster />
    </div>
  );
};

export default LandingPage;